import axios from "axios";
import Cookies from "universal-cookie";

const cookies = new Cookies();

// Get all relations
export const getRelationApi = async (url: string) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.get(
            `${url}/Relation/GetAllRelations`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Get relations by UserId
export const getRelationByUserIdApi = async (url: string) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.get(
            `${url}/Relation/GetRelationsByUserId`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Add a relation
export const addRelationApi = async (
    url: string,
    relationType: string,
    relationUserId: string
  
) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.post(
            `${url}/Relation/Create`, {
            relationType,
            relationUserId
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Update a relation
export const updateRelationApi = async (
    Id: string,
    relationType: string,
    relationUserId: string,
    url: string,
) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.post(
            `${url}/Relation/Update`, {
                Id,
                relationType,
                relationUserId
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};
